import {useEffect} from 'react';

import {
    Hub,
    HubPayload
} from '@aws-amplify/core';
import {Cache} from '@aws-amplify/cache';

import {
    Navigate,
    useNavigate
} from 'react-router-dom';

import {
    getWithIdTokenPayload,
    update as updateAccount
} from '../../accounts/services/AccountsService';
import {AuthorizingIndicator} from "../components/AuthorizingIndicator";
import {useAccounts} from "../../accounts/hooks/useAccounts";
import {ActivityEventsService} from "../../activity-events/services/ActivityEventsService.ts";


export const IndexPage = () => {
    const navigate = useNavigate();
    const {handleClearSelection} = useAccounts();

    useEffect(() => {
        handleClearSelection();
    }, []);


    const hubListenerCancelToken = Hub.listen('auth', (data) => {
        const {payload} = data;
        onAuthEvent(payload);
    });


    const onAuthEvent = (payload: HubPayload) => {

        switch (payload.event) {
            case 'signIn':
                handleSignInEvent(payload)
                break;
            case 'cognitoHostedUI':
                ActivityEventsService.add(
                    'SSO Authentication Successful',
                    `Cognito Hosted UI authentication successful`,
                    undefined
                );
                break;
            case 'signIn_failure':
                ActivityEventsService.add(
                    'Sign-In Failed',
                    `Authentication failed`,
                    undefined
                );
                break;
            case 'cognitoHostedUI_failure':
                ActivityEventsService.add(
                    'SSO Authentication Failed',
                    `Cognito Hosted UI authentication failed`,
                    undefined
                );
                break;
        }
    };

    const handleSignInEvent = async (payload: HubPayload) => {

        hubListenerCancelToken()

        console.debug('LOGIN APP. INDEX PAGE. EVENT', payload.event);

        if (payload.data.signInUserSession === null) {
            return;
        }

        console.log(
            'LOGIN APP. INDEX PAGE. PAYLOAD',
            payload.data
        );

        let idTokenPayload =
            payload.data.signInUserSession.idToken.payload;
        console.log(
            'LOGIN APP. INDEX PAGE. ID TOKEN PAYLOAD',
            JSON.stringify(idTokenPayload, null, 2)
        );

        const testing = false;
        if (testing) {
            const testPayload: any = {
                'email': '122555@panasonic.aero',
                'identities': [
                    {
                        'userId': '122555@panasonic.aero',
                        'providerName': 'panasonic',
                        'providerType': 'email'
                    }
                ]
            }

            idTokenPayload = testPayload;

        }


        console.debug('FIND ACCOUNT WITH TOKEN PAYLOAD', idTokenPayload)

        const account = await getWithIdTokenPayload(idTokenPayload)
        console.debug('GET ACCOUNT WITH PAYLOAD RESULT', JSON.stringify(account, null, 2))

        if (account) {

            console.debug('FOUND ACCOUNT IN HOME PAGE', JSON.stringify(account, null, 2))

            ActivityEventsService.add(
                'User Signed In Successfully',
                `Completed sign-in for: ${account.emailAddress}`,
                account.emailAddress
            );

            await updateAccount(
                account.id,
                Object.assign({}, account, {
                    isAuthorizing: 'no',
                })
            );
            navigate(`/accounts/${account.id}/redirect`)
        } else {
            let email = idTokenPayload['email'];

            ActivityEventsService.add(
                'Sign-In Failed - Account Not Found',
                `User authenticated but no account profile exists: ${email}`,
                email
            );

            Cache.setItem('pac-authorizing', 'no');
            // Don't set isAuthorizing to false here - it will trigger re-render and Navigate to /accounts
            // setIsAuthorizing(false)
            navigate(`/accounts/not-found/${encodeURIComponent(email)}`)
        }

    }


    // console.debug('LOGIN APP. INDEX PAGE. EVENT - canceling the listener');
    // hubListenerCancelToken(); // stop listening for messages

    let authorizing = Cache.getItem('pac-authorizing');

    if (authorizing === 'yes') {
        return <AuthorizingIndicator/>;
    } else {
        return <Navigate to="/accounts"/>;
    }


};
